// Stored shape of a deployment's `main_color`. The keys predate the picker's
// labels: `accent` is the light color shown as "Primary (Backgrounds)" and
// `primary` the dark one shown as "Secondary (Buttons)". Nothing else on the
// platform reads a `secondary` key from this object.
export interface ColorTheme {
  primary: string;
  accent: string;
}

export const DEFAULT_THEME: ColorTheme = {
  primary: "#1E1E1E",
  accent: "#F0F5FA",
};

export const isDefaultTheme = (theme: {
  primary?: string;
  accent?: string;
}): boolean =>
  theme.primary === DEFAULT_THEME.primary &&
  theme.accent === DEFAULT_THEME.accent;
